import { render, staticRenderFns } from "./usappbkok.vue?vue&type=template&id=a6efddb6&scoped=true&"
import script from "./usappbkok.vue?vue&type=script&lang=js&"
export * from "./usappbkok.vue?vue&type=script&lang=js&"
import style0 from "./usappbkok.vue?vue&type=style&index=0&id=a6efddb6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6efddb6",
  null
  
)

export default component.exports